import authentication from './authentication';
import panelSlider from './panel-slider';
import doctor from './doctor';
import appointment from './appointment';
import searchSuggestion from './search-suggestion';
import consultation from './consultation';

const combineReducer = {
  authentication,
  panelSlider,
  doctor,
  appointment,
  searchSuggestion,
  consultation
};

export default combineReducer;
